import type { Components, Theme } from '@mui/material/styles'

export const MuiAlertOverride: Components<Theme>['MuiAlert'] = {
  styleOverrides: {
    // MUI derives filled-variant text from the palette's contrastText, which
    // reads washed out against these brand colors. Force white for every
    // severity so copy stays legible in both modes.
    filled: ({ theme }) => ({
      color: theme.palette.common.white
    })
  }
}
